import { render, staticRenderFns } from "./test15minmanage.vue?vue&type=template&id=16f37298&"
import script from "./test15minmanage.vue?vue&type=script&lang=js&"
export * from "./test15minmanage.vue?vue&type=script&lang=js&"
import style0 from "./test15minmanage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports